import { Elements } from "../types/Elements";
import { NavBarElement } from "../types/NavBarElement";

interface NavBarIconProps {
    element: NavBarElement;
    focused?: boolean;
    menuOpen?: boolean;
}

export const NavBarIcon: React.FC<NavBarIconProps> = ({ element, focused, menuOpen }) => {
    const color = focused ? "rgba(114, 168, 253, 1)" : "white";
    const icons: Record<Elements, JSX.Element> = {
        [NavBarElement.Home]: (
            <svg width="24" height="22" viewBox="0 0 24 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.9998 0L0.420898 11.5789H2.73669V22H21.263V11.5789H23.5788L11.9998 0ZM11.9998 3.47368L18.9472 10.4211V19.6842H5.05248V10.4211L11.9998 3.47368ZM11.4209 13.8947H8.52616L12.5788 5.78947V10.4211H15.4735L11.4209 18.5263V13.8947Z"
                    fill={color}
                />
            </svg>
        ),
        [NavBarElement.HealthPlan]: (
            <svg width="22" height="21" viewBox="0 0 22 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15.8767 19.3667L13.5317 15.3067C14.675 14.4667 15.4683 13.16 15.6317 11.6667H20.3333C20.135 14.8867 18.4083 17.6867 15.8767 19.3667ZM12.1667 4.70167V0C17.1833 0.303333 21.1967 4.31667 21.5 9.33333H16.7983C16.53 6.895 14.605 4.97 12.1667 4.70167ZM5.16667 11.0833C5.16667 11.83 5.31833 12.5417 5.61 13.1833L1.55 15.5283C0.873333 14.1867 0.5 12.6817 0.5 11.0833C0.5 5.79833 4.63 1.48167 9.83333 1.16667V5.86833C7.20833 6.16 5.16667 8.37667 5.16667 11.0833ZM10.4167 21C6.95167 21 3.90667 19.25 2.13333 16.5433L6.19333 14.1983C7.15 15.4933 8.66667 16.3333 10.4167 16.3333C11.1633 16.3333 11.875 16.1817 12.5167 15.89L14.8617 19.95C13.52 20.6267 12.015 21 10.4167 21Z"
                    fill={color}
                />
            </svg>

        ),
        [NavBarElement.Diagnostica]: (
            <svg width="18" height="22" viewBox="0 0 18 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M2.4002 0C1.81672 0 1.25714 0.231785 0.84456 0.644365C0.43198 1.05694 0.200195 1.61652 0.200195 2.2V19.8C0.200195 20.3835 0.43198 20.9431 0.84456 21.3556C1.25714 21.7682 1.81672 22 2.4002 22H15.6002C16.1837 22 16.7432 21.7682 17.1558 21.3556C17.5684 20.9431 17.8002 20.3835 17.8002 19.8V6.6L11.2002 0H2.4002ZM2.4002 2.2H10.1002V7.7H15.6002V19.8H2.4002V2.2ZM4.6002 11V13.2H13.4002V11H4.6002ZM4.6002 15.4V17.6H10.1002V15.4H4.6002Z"
                    fill={color}
                />
            </svg>
        ),
        [NavBarElement.Equipe]: (
            <svg width="20" height="23" viewBox="0 0 20 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13.2658 16.399C16.7388 17.0545 19.1998 18.7335 19.1998 20.7V23H0.799805V20.7C0.799805 18.7335 3.2608 17.0545 6.7338 16.399L9.9998 21.85L13.2658 16.399ZM5.3998 6.9H14.5998V9.2C14.5998 10.42 14.1152 11.59 13.2525 12.4527C12.3898 13.3154 11.2198 13.8 9.9998 13.8C8.77981 13.8 7.60978 13.3154 6.74711 12.4527C5.88445 11.59 5.3998 10.42 5.3998 9.2V6.9ZM5.3998 5.75L5.8713 1.035C5.9288 0.4485 6.4233 0 7.0213 0H12.9898C13.5763 0 14.0708 0.4485 14.1283 1.035L14.5998 5.75H5.3998ZM9.9998 1.15H8.8498V2.3H7.6998V3.45H8.8498V4.6H9.9998V3.45H11.1498V2.3H9.9998V1.15Z"
                    fill={color}
                />
            </svg>
        ),
        [NavBarElement.Menu]: (
            menuOpen ? <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="2.06519" width="23.2423" height="2.21355" transform="rotate(45 2.06519 0)" fill="#72A8FD" />
                <rect x="0.5" y="16.4346" width="23.2423" height="2.21355" transform="rotate(-45 0.5 16.4346)" fill="#72A8FD" />
            </svg>
                :
                <svg width="21" height="14" viewBox="0 0 21 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M0 0H21V2.33333H0V0ZM0 5.83333H21V8.16667H0V5.83333ZM0 11.6667H21V14H0V11.6667Z"
                        fill={color}
                    />
                </svg>
        ),
        [NavBarElement.Chat]: (
            <svg width={21} height={20} viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10.0282 0C8.71497 0 7.41461 0.258658 6.20135 0.761205C4.9881 1.26375 3.8857 2.00035 2.95712 2.92893C1.08175 4.8043 0.0281864 7.34784 0.0281864 10C0.0194442 12.3091 0.818979 14.5485 2.28819 16.33L0.288186 18.33C0.149429 18.4706 0.0554325 18.6492 0.0180584 18.8432C-0.0193158 19.0372 0.0016069 19.2379 0.0781863 19.42C0.161244 19.5999 0.29589 19.7511 0.465033 19.8544C0.634176 19.9577 0.830187 20.0083 1.02819 20H10.0282C12.6804 20 15.2239 18.9464 17.0993 17.0711C18.9746 15.1957 20.0282 12.6522 20.0282 10C20.0282 7.34784 18.9746 4.8043 17.0993 2.92893C15.2239 1.05357 12.6804 0 10.0282 0ZM10.0282 18H3.43819L4.36819 17.07C4.55444 16.8826 4.65898 16.6292 4.65898 16.365C4.65898 16.1008 4.55444 15.8474 4.36819 15.66C3.05877 14.352 2.24336 12.6305 2.06088 10.7888C1.87839 8.94705 2.34013 7.09901 3.36741 5.55952C4.3947 4.02004 5.92398 2.88436 7.6947 2.34597C9.46543 1.80759 11.368 1.8998 13.0784 2.60691C14.7888 3.31402 16.201 4.59227 17.0746 6.22389C17.9482 7.85551 18.2291 9.73954 17.8693 11.555C17.5096 13.3705 16.5315 15.005 15.1017 16.1802C13.672 17.3554 11.8789 17.9985 10.0282 18Z"
                    fill={color}
                />
            </svg>
        ),
    };
    return icons[element] || null;
}

export default NavBarIcon
